import axios from 'axios'
import store from '@/store/store'
import router from '@/router'
import i18n from '@/plugins/vue-i18n'

const $http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

const $httpAuth = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

$httpAuth.interceptors.request.use((config) => {
  const token = store.getters.getToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    console.log('Token is null')
  }
  return config
}, (err) => {
  console.error('Error', err)
  return Promise.reject(err)
})

$httpAuth.interceptors.response.use((response) => { // intercept the global error
  return response
}, async (err) => {
  if (err.response.status === 401) {
    this.$root.$snackbar.show(i18n.t('message.needLoginAgain'))
    await store.dispatch('logoutUser')
    router.push('/login')
  }
  return Promise.reject(err)
})

export { $http, $httpAuth }
